<div class="t-popup popup-graphs" style='display: block;height:100%;'>

    <div class="popup-close"></div>
    
    <div class="popup-frame">
       
        <div class="patient-ob-box popup-body">
            
            <div class="h100 m-box" *ngIf="! isReports">

                <h2>Exam Search</h2>
                <div>
                    <strong style="margin-right: 0.5em;">
                        From:
                    </strong>
                    <input [matDatepicker]="startDatepicker" [(ngModel)]="startdate" [min]="searchmin"
                        class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP" (click)="startDatepicker.open()"
                        style="margin-right: 1em;">
                    <mat-datepicker #startDatepicker></mat-datepicker>
                    <strong style="margin-right: 0.5em;">
                        Until:
                    </strong>
                    <input [matDatepicker]="endDatepicker" [(ngModel)]="enddate" [max]="searchmax" (click)="endDatepicker.open()"
                        class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP" style="margin-right: 1em;">
                    <mat-datepicker #endDatepicker></mat-datepicker>
                </div>
                <div class="h100 l-flex l-column">

                    <div class="l-fg1">

                        <div class="">
                            
                            <!-- new exam top (start) -->
                            <div class="l-flex-c l-flex-w l-justify h50 new_exam-head">
                                
                                <label class="t-label-top">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="All" (click)="setVals('All')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        All
                                    </span>
                                </label>

                                
                                <label class="t-label-top" *ngIf="isUSG">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="Ultrasound" (click)="setVals('Ultrasound')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Ultrasound
                                    </span>
                                </label>
                                <label class="t-label-top" *ngIf="isUSG">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="etype" class="custom-check" value="Endoscopy" (click)="setVals('Endoscopy')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Endoscopy
                                    </span>
                                </label>
                                
                               
                                
                            </div>	
                            <!-- new exam top (end) -->
                            <div class="linked-radios-list linked-radios-set">
                           
                                <ng-container *ngIf="etype == 'OB'">
                                
                                   
                                <label class="linked-radios-item" (click)="setE($event,'1st')">
                                    <input type="checkbox" name="1st" [checked]="exams['1st']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">1st</span>
                                        <span class="linked-radios-duration"> 1-9 Weeks</span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>
                                
                                <label class="linked-radios-item" (click)="setE($event,'NT')">
                                    <input type="checkbox" name="NT" [checked]="exams['NT']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">NT</span>
                                        <span class="linked-radios-duration"> 12-15 Weeks</span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>
                                
                                <label class="linked-radios-item" (click)="setE($event,'Early')">
                                    <input type="checkbox" name="Early" [checked]="exams['Early']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">Early Anatomy</span>
                                        <span class="linked-radios-duration"> 14-16 Weeks</span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>

                                <label class="linked-radios-item" (click)="setE($event,'2nd/3rd')">
                                    <input type="checkbox" name="2nd/3rd" [checked]="exams['2nd/3rd']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">2nd/3rd Trimester</span>
                                        <span class="linked-radios-duration">12-40 Weeks</span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>

                                <label class="linked-radios-item" (click)="setE($event,'Weight Assessment')">
                                    <input type="checkbox" name="Weight Assessment" [checked]="exams['Weight Assessment']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">Weight Assessment</span>
                                        <span class="linked-radios-duration">12-40 Weeks</span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>
                                <label class="linked-radios-item" *ngIf="ls.hastech && ls.ishospital" (click)="setE($event,'Tech Exam')">
                                    <input type="checkbox" name="Tech Exam" [checked]="exams['Tech Exam']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">בדיקת טכנאי</span>
                                        <span class="linked-radios-duration">12-40 Weeks</span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>
                                
                                <label class="linked-radios-item" (click)="setE($event,'Late')">
                                    <input type="checkbox" name="Late" [checked]="exams['Late']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">Late Anatomy</span>
                                        <span class="linked-radios-duration"> 22-23 Weeks</span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>
                                
                                                                    
                                <label class="linked-radios-item" (click)="setE($event,'Specialized')">
                                    <input type="checkbox" name="Specialized" [checked]="exams['Specialized']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">Specialized</span>
                                        <span class="linked-radios-duration">12-40 Weeks</span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>

                                <label class="linked-radios-item" (click)="setE($event,'Fetal Echo')">
                                    <input type="checkbox" name="Fetal Echo" [checked]="exams['Fetal Echo']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">Fetal Echo</span>
                                        <span class="linked-radios-duration">12-40 Weeks</span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>
                                <label class="linked-radios-item" (click)="setE($event,'Emergency Room')" *ngIf="ls.hasEmergencyRoom">
                                    <input type="checkbox" name="Emergency Room" [checked]="exams['Emergency Room']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">Emergency Room</span>
                                        <span class="linked-radios-duration">12-40 Weeks</span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>
                                </ng-container>

                                <ng-container *ngIf="etype == 'Ultrasound'">
                                    <label class="linked-radios-item" (click)="setE($event,'Abdomen US')">
                                        <input type="checkbox" name="Abdomen US" [checked]="exams['Abdomen US']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Abdomen US</span>
                                        </span>
                                    </label>
                                    <!-- <label class="linked-radios-item" (click)="setE($event,'MSK Musculoskeletal')">
                                        <input type="checkbox" name="MSK Musculoskeletal" [checked]="exams['MSK Musculoskeletal']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">MSK Musculoskeletal</span>
                                        </span>
                                    </label> -->
                                    <label class="linked-radios-item" (click)="setE($event,'MSK & Soft Tissues')">
                                        <input type="checkbox" name="MSK & Soft Tissues" [checked]="exams['MSK & Soft Tissues']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">MSK &amp; Soft Tissues</span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Neck scan')">
                                        <input type="checkbox" name="Neck scan" [checked]="exams['Neck scan']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Neck scan</span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Ultrasound Scan Summary')">
                                        <input type="checkbox" name="Ultrasound Scan Summary" [checked]="exams['Ultrasound Scan Summary']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Ultrasound Scan Summary</span>
                                        </span>
                                    </label>
                                </ng-container>
                                <ng-container *ngIf="etype == 'Endoscopy'">
                                    <label class="linked-radios-item" (click)="setE($event,'Endoscopy')">
                                        <input type="checkbox" name="Endoscopy" [checked]="exams['Endoscopy']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Endoscopy</span>
                                        </span>
                                    </label>
                                </ng-container>
                                <label class="linked-radios-item" *ngIf="etype == 'GYN'" (click)="setE($event,'Gynecology')">
                                    <input type="checkbox" name="Gynecology" [checked]="exams['Gynecology']" />
                                    <span class="linked-radios-row">
                                        <span class="l-fg1 linked-radios-title">Gynecology</span>
                                        <span class="linked-radios-duration"></span>
                                        <span class="linked-radios-counter"><i>1</i></span>
                                    </span>
                                </label>
                                
                              
                            </div>

                        </div>

                    </div>

                    <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">

                        <a class="btn-primary -exit" (click)="closed.emit(null)" style='padding-top: 1em;'>
                            Cancel
                        </a>
                        <button class="btn-primary -search"  (click)="search()" *ngIf="cansearch">
                            Search
                        </button>
                    </div>
                    
                </div>

            </div>
            <div class="h100 m-box" *ngIf="isReports">
                <h2>Reports</h2>
                <!-- [max]="searchmax" -->
                <ng-container *ngIf="reportstype != 'Macabifin'">
                    From  <input [matDatepicker]="startDatepicker"  [(ngModel)]="startdate" [max]="searchmax"  class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP" (click)="startDatepicker.open()">
                    <mat-datepicker #startDatepicker></mat-datepicker>
                    Until
                    <input [matDatepicker]="endDatepicker"  [(ngModel)]="enddate" [max]="searchmax"  (click)="endDatepicker.open()" class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP">
                    <mat-datepicker #endDatepicker></mat-datepicker>
                </ng-container>
                <div class="month-year-picker" *ngIf="reportstype == 'Macabifin'">
                    <label>Month:</label>
                    <select [(ngModel)]="selectedMonth" class="t-select t-field">
                        <option *ngFor="let m of months" [value]="m.value">{{m.name}}</option>
                    </select>
                    <label>Year:</label>
                    <select [(ngModel)]="selectedYear" class="t-select t-field">
                        <option *ngFor="let y of years" [value]="y">{{y}}</option>
                    </select>
                </div>
                <div class="h100 l-flex l-column">
                    <div class="l-fg1">
                        <div class="">
                            <div class="l-flex-c l-flex-w l-justify h50 new_exam-head">
                                <label class="t-label-top">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="AllReports" (click)="setVals('AllReports')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        All
                                    </span>
                                </label>
                                <label class="t-label-top" *ngIf="ls.isAdmin">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="Refferelnum" (click)="setVals('Refferelnum')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Missing Refferel number
                                    </span>
                                </label>
                                <label class="t-label-top">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="HMO" (click)="setVals('HMO')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        BY HMO
                                        <select class="t-field t-select" *ngIf="reportstype =='HMO'" [(ngModel)]="hmostype">
                                            <option value="Macabi">מכבי</option>
                                            <option value="Leumit">לאומית</option>
                                            <option value="Meuhedet">מאוחדת</option>
                                            <option value="Clalit">כללית</option>
                                            <option value="Private">פרטי</option>
                                            <option value="IDF">צהל</option>
                                            <option value="null">לא שויכו</option>
                                        </select>
                                    </span>
                                </label>
                                <label class="t-label-top" *ngIf="ls.isAdmin || ls.finances">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="Macabi" (click)="setVals('Macabi')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Sent to Macabi
                                    </span>
                                </label>
                                <label class="t-label-top" *ngIf="ls.finances">
                                    <input type="radio" name="TEMP_name" [(ngModel)]="reportstype" class="custom-check" value="Macabifin" (click)="setVals('Macabi')"/>
                                    <i class="customInput-display"></i>
                                    <span>
                                        Macabi financial report
                                    </span>
                                </label>

                            </div>
                            <!-- <div class="linked-radios-list linked-radios-set" *ngIf="false">
                           
                                <ng-container *ngIf="reportstype == 'HMO'">
                                    <label class="linked-radios-item" (click)="setE($event,'TTE Adults')">
                                        <input type="checkbox" name="TTE Adults" [checked]="exams['TTE Adults']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">TTE Adults</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Stress-Echo')">
                                        <input type="checkbox" name="Stress-Echo" [checked]="exams['Stress-Echo']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Stress-Echo</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Duplex Carotid')">
                                        <input type="checkbox" name="Duplex Carotid" [checked]="exams['Duplex Carotid']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Duplex Carotid</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Stress')">
                                        <input type="checkbox" name="Stress" [checked]="exams['Stress']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Stress</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                </ng-container> -->
                                <!-- <ng-container *ngIf="etype == 'ECG'">
                                    <label class="linked-radios-item" (click)="setE($event,'ECG')">
                                        <input type="checkbox" name="ECG" [checked]="exams['ECG']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">ECG</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                    <label class="linked-radios-item" (click)="setE($event,'Ergometry')">
                                        <input type="checkbox" name="Ergometry" [checked]="exams['Ergometry']" />
                                        <span class="linked-radios-row">
                                            <span class="l-fg1 linked-radios-title">Ergometry</span>
                                            <span class="linked-radios-duration"></span>
                                            <span class="linked-radios-counter"><i>1</i></span>
                                        </span>
                                    </label>
                                </ng-container> -->
                                
                                
                            <!-- </div> -->

                        </div>
                    </div>
                    <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">

                        <a class="patient-ob-btn -exit" (click)="closed.emit(null)" style='padding-top: 1em;'>
                            Cancel
                        </a>
                        <button class="patient-ob-btn -search"  (click)="search()" *ngIf="cansearch">
                            Search
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
